// Author: Shubham Sonkar

// Import necessary dependencies and styles
import React, { useState, useReducer, Suspense } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useSetting } from "../hooks/Hooks";
import Skeleton from "@mui/material/Skeleton";
import CryptoJS from "crypto-js";
import { IdleTimerProvider } from "react-idle-timer";
// import { useQuery } from "react-query";
import { CheckUserLogin, logout } from "../hooks/Auth/Authentication";
import { CustomModal } from "../components/CustomModal/CustomModal";
import IdleImg from "./../assets/Image/idle.png";
import { Button } from "@mui/material";
import Cookies from "js-cookie";
// import { onMessageListener, messaging } from "./firebase";
// import { getToken } from "firebase/messaging";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { CustomDescription, CustomHeading } from "../components/Common/Common";
import { setDispatchDashboard } from "../hooks/Function";
import  ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";

// Define the Main component
const Main = () => {
  // Retrieve globalData from useSetting hook
  const { globalData } = useSetting();

  const [idleModal, setIdleModal] = useState(false);
  const [leadModal, setLeadModal] = useState(false);

  // Set initial state for myglobalData
  const [myglobalData, setMyglobalData] = React.useState(globalData);
  // Styled component for DrawerHeader
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    ...theme.mixins.toolbar,
  }));

  // ======================================================================================================
  // Notification
  const [token, setToken] = React.useState("");
  const [notification, setNotification] = React.useState({
    title: "",
    body: "",
  });

  // const requestForToken = async () => {
  //   try {
  //     const currentToken = await getToken(messaging, {
  //       vapidKey: process.env.REACT_APP_VAPID_KEY,
  //     });
  //     if (currentToken) {
  //       console.log("current token for client: ", currentToken);
  //       setToken(currentToken);
  //     } else {
  //       // Show permission request UI
  //       console.log(
  //         "No registration token available. Request permission to generate one."
  //       );
  //     }
  //     // const res = undefined;
  //     // console.log(res);
  //   } catch (err) {
  //     setToken("notificationblocked");
  //   }
  // };

  // React.useEffect(() => {
  //   if (!notification?.title) {
  //     requestForToken();
  //   } else {
  //     console.log("Background Message");
  //   }
  // }, []);

  // onMessageListener()
  //   .then((payload) => {
  //     toast.success(
  //       <div>
  //         <CustomHeading
  //           Heading={payload.notification.title}
  //           style={{ fontSize: "14px" }}
  //         />
  //         <CustomDescription Description={payload.notification.body} />
  //       </div>,
  //       {
  //         position: toast.POSITION.BOTTOM_RIGHT,
  //         icon: false,
  //       }
  //     );
  //     // const { data: { icon } } = payload;
  //     setNotification({
  //       title: payload?.notification?.title,
  //       body: payload?.notification?.body,
  //     });
  //     // new Notification(title, { body, icon: CRMLogo });
  //   })
  //   .catch((err) => console.log("failed: ", err));
  // ======================================================================================================

  // State for app startup and loading
  const [appInitialised, setAppInitialised] = useState(false);
  const [loading, setLoading] = React.useState(true);

  // Function to load default screen on app startup
  function loadDefault() {
    console.log("load default");
    if (appInitialised === false) {
      // check last active screen from local storage
      if (localStorage.getItem("currScreen") !== null) {
        // Set default screen to Login if not found
        if (
          localStorage.getItem("currScreen").length === 0 ||
          localStorage.getItem("currScreen") === ""
        ) {
          localStorage.setItem("currScreen", "Login");
        }
        let currScreen = localStorage.getItem("currScreen");
        dispatch({ event: currScreen });
      } else {
        // Set default screen to Login if no previous screen found
        dispatch({ event: "Login" });
      }
    }
  }

  // Function to encrypt and set data in local storage
  function setLocalData(key, value) {
    let CryptoJSKey = globalData.CompanyName + "@" + globalData.Version;
    var user_data = CryptoJS.AES.encrypt(value, CryptoJSKey).toString();
    localStorage.setItem(key, user_data);
  }

  function setLocalPage(key, value) {
    localStorage.setItem(key, value);
  }

  function setLocalPageSize(key, value) {
    localStorage.setItem(key, value);
  }

  // const LoginCheck = useQuery("logincheck", () => {
  //   return CheckUserLogin();
  // });

  // Mapping of event names to corresponding components
  const componentConfig = {
    // Map event names to their corresponding components
    Login: myglobalData.login.path,
    register: myglobalData.register.path,
    verifyotp: myglobalData.verifyotp.path,
    changepassword: myglobalData.pages.changepassword,
    forgotpassword: myglobalData.pages.forgotpassword,

    dashboard: myglobalData.pages.dashboard,

    addcompany: myglobalData.pages.company.addcompany,
    editcompany: myglobalData.pages.company.editcompany,
    viewcompany: myglobalData.pages.company.viewcompany,
    companydetails: myglobalData.pages.company.companydetails,
    quickeditcompany: myglobalData.pages.company.quickeditcompany,

    viewsanctiondetails: myglobalData.pages.sanction.viewsanctiondetails,
    addsanctiondetails: myglobalData.pages.sanction.addsanctiondetails,
    editsanctiondetails: myglobalData.pages.sanction.editsanctiondetails,
    quickeditsanctiondetails: myglobalData.pages.sanction.quickeditsanctiondetails,
    sanctiondetails: myglobalData.pages.sanction.sanctiondetails,

    viewvendor: myglobalData.pages.vendor.viewvendor,
    addvendor: myglobalData.pages.vendor.addvendor,
    editvendor: myglobalData.pages.vendor.editvendor,
    vendordetails: myglobalData.pages.vendor.vendordetails,
    addlender: myglobalData.pages.vendor.addlender,
    editlender: myglobalData.pages.vendor.editlender,
    viewlender: myglobalData.pages.vendor.viewlender,
    lenderdetails: myglobalData.pages.vendor.lenderdetails,

    viewinvoice: myglobalData.pages.invoice.viewinvoice,
    addinvoice: myglobalData.pages.invoice.addinvoice,
    editinvoice: myglobalData.pages.invoice.editinvoice,
    quickeditinvoice: myglobalData.pages.invoice.quickeditinvoice,
    invoicedetails: myglobalData.pages.invoice.invoicedetails,
    pendinginvoices: myglobalData.pages.invoice.pendinginvoices,
    invoicestatements: myglobalData.pages.invoice.invoicestatements,
    dashboardinvoices: myglobalData.pages.invoice.dashboardinvoices,
    changeinvoicestatus: myglobalData.pages.invoice.changeinvoicestatus,
    quickeditfileupload: myglobalData.pages.invoice.quickeditfileupload,
    viewinvoicestatement: myglobalData.pages.invoice.viewinvoicestatement,
    addinvoicestatement: myglobalData.pages.invoice.addinvoicestatement,
    editinvoicestatement: myglobalData.pages.invoice.editinvoicestatement,
    invoicstatementedetails: myglobalData.pages.invoice.invoicstatementedetails,

    addnotice: myglobalData.pages.notice.addnotice,
    editnotice: myglobalData.pages.notice.editnotice,
    viewnotice: myglobalData.pages.notice.viewnotice,
    noticedetails: myglobalData.pages.notice.noticedetails,

    bankname: myglobalData.pages.dynamicfields.bankname,
    accounttype: myglobalData.pages.dynamicfields.accounttype,
    producttype: myglobalData.pages.dynamicfields.producttype,
    institutename: myglobalData.pages.dynamicfields.institutename,
    tenure: myglobalData.pages.dynamicfields.tenure,
    industry: myglobalData.pages.dynamicfields.industry,
    products: myglobalData.pages.dynamicfields.products,
    ratingagency: myglobalData.pages.dynamicfields.ratingagency,
    customemail: myglobalData.pages.dynamicfields.customemail,
    customwhatsapp: myglobalData.pages.dynamicfields.customwhatsapp,
    
    // allusers: myglobalData.pages.user.allusers,
    // useranalyst: myglobalData.pages.user.useranalyst,
    adduser: myglobalData.pages.user.adduser,
    edituser: myglobalData.pages.user.edituser,
    // viewuser: myglobalData.pages.user.viewuser,
    userdetails: myglobalData.pages.user.userdetails,

    viewlcsanctiondetails: myglobalData.pages.lcsanction.viewlcsanctiondetails,
    addlcsanctiondetails: myglobalData.pages.lcsanction.addlcsanctiondetails,
    editlcsanctiondetails: myglobalData.pages.lcsanction.editlcsanctiondetails,
    quickeditlcsanctiondetails: myglobalData.pages.lcsanction.quickeditlcsanctiondetails,
    lcsanctiondetails: myglobalData.pages.lcsanction.lcsanctiondetails,

    viewlcdetails: myglobalData.pages.lc.viewlcdetails,
    addlcdetails: myglobalData.pages.lc.addlcdetails,
    editlcdetails: myglobalData.pages.lc.editlcdetails,
    quickeditlcdetails: myglobalData.pages.lc.quickeditlcdetails,
    editlcamendment: myglobalData.pages.lc.editlcamendment,
    lcdetails: myglobalData.pages.lc.lcdetails,

    viewboedetails: myglobalData.pages.boe.viewboedetails,
    addboedetails: myglobalData.pages.boe.addboedetails,
    editboedetails: myglobalData.pages.boe.editboedetails,
    quickeditboedetails: myglobalData.pages.boe.quickeditboedetails,
    boedetails: myglobalData.pages.boe.boedetails,
    dashboardboedetails: myglobalData.pages.boe.dashboardboedetails,

    viewwcldisbursement: myglobalData.pages.wcldisbursement.viewwcldisbursement,
    addwcldisbursement: myglobalData.pages.wcldisbursement.addwcldisbursement,
    editwcldisbursement: myglobalData.pages.wcldisbursement.editwcldisbursement,
    wcldisbursementdetails: myglobalData.pages.wcldisbursement.wcldisbursementdetails,

    addwclsanction: myglobalData.pages.wclsanction.addwclsanction,
    editwclsanction: myglobalData.pages.wclsanction.editwclsanction,
    viewwclsanction: myglobalData.pages.wclsanction.viewwclsanction,
    wclsanctiondetails: myglobalData.pages.wclsanction.wclsanctiondetails,

    addclient: myglobalData.pages.client.addclient,
    editclient: myglobalData.pages.client.editclient,
    viewclient: myglobalData.pages.client.viewclient,
    clientdetails: myglobalData.pages.client.clientdetails,

    addclientcontact: myglobalData.pages.clientcontact.addclientcontact,
    editclientcontact: myglobalData.pages.clientcontact.editclientcontact,
    viewclientcontact: myglobalData.pages.clientcontact.viewclientcontact,
    clientcontact: myglobalData.pages.clientcontact.clientcontact,

    addclientmeeting: myglobalData.pages.clientmeeting.addclientmeeting,
    editclientmeeting: myglobalData.pages.clientmeeting.editclientmeeting,
    viewclientmeeting: myglobalData.pages.clientmeeting.viewclientmeeting,
    clientmeeting: myglobalData.pages.clientmeeting.clientmeeting,

    customwhatsapp: myglobalData.pages.whatsapp.customwhatsapp,

    addbank: myglobalData.pages.bank.addbank,
    editbank: myglobalData.pages.bank.editbank,
    viewbank: myglobalData.pages.bank.viewbank,
    bankdetails: myglobalData.pages.bank.bankdetails,

    addbankcontact: myglobalData.pages.bankcontact.addbankcontact,
    editbankcontact: myglobalData.pages.bankcontact.editbankcontact,
    viewbankcontact: myglobalData.pages.bankcontact.viewbankcontact,
    bankcontact: myglobalData.pages.bankcontact.bankcontact,

    addbankmeeting: myglobalData.pages.bankmeeting.addbankmeeting,
    editbankmeeting: myglobalData.pages.bankmeeting.editbankmeeting,
    viewbankmeeting: myglobalData.pages.bankmeeting.viewbankmeeting,
    bankmeeting: myglobalData.pages.bankmeeting.bankmeeting,

    allnotifications: myglobalData.pages.other.allnotifications,

    profile: myglobalData.pages.other.profile,
    crmsetting: myglobalData.pages.other.crmsetting,
    loader: myglobalData.pages.other.loader,
  };

  // Reducer for navigation state
  function navReducer(state, action) {
    const tempData = { ...myglobalData };
    // Handle special events and update global data accordingly
    if (action.event === "sotre_search_data") {
      setLocalData("sotre_search_data", action.data);
    } else if (action.event === "updateglobal_userdata") {
      setLocalData("updateglobal_userdata", action.data);
      tempData.user_data = action.data;
      setMyglobalData(tempData);
    } else if (action.event === "store_new_data") {
      setLocalData("store_new_data", action.data);
    } else if (action.event === "setlocaldata") {
      setLocalData(action.key, action.value);
    } else if (action.event === "notificationType") {
      setLocalData("notificationType", action.value);
    } else if (action.event === "setpagination") {
      setLocalPage(action.key, action.data);
    } else if (action.event === "setpagesize") {
      setLocalPageSize(action.key, action.data);
    } 
    else {
      // Handle regular navigation events
      const component = componentConfig[action.event];
      if (component) {
        // Update current and previous screen in local storage
        localStorage.setItem(
          "previousScreen",
          localStorage.getItem("currScreen")
        );
        setTimeout(() => {
          localStorage.setItem("currScreen", action.event);
          tempData.currScreen = component;
          setMyglobalData(tempData);
        }, 1);
      } else {
        console.log("No action");
      }
    }
  }
  // UseReducer hook for navigation
  const [state, dispatch] = useReducer(navReducer);

  React.useEffect(() => {
    setDispatchDashboard(dispatch);
    // Perform initialization on app startup
    if (appInitialised === false) {
      setAppInitialised(true);
      // if (!LoginCheck.isLoading) {
      //   if (LoginCheck.data?.data == "Session found") {
      loadDefault();
      // } else {
      //   dispatch({ event: "Login" });
      // }
      // }
    }
    // Set loading to false after a short delay
    setTimeout(() => {
      setLoading(false);
    }, 10);
  }, []);

  const logout_User = () => {
    logout(Cookies.get("token"))
      .then((response) => {
        if (response.data === "Logout Done") {
          dispatch({ event: "Login" });
          setIdleModal(false);
          setTimeout(() => {
            Cookies.remove("user", { path: "/", domain: globalData.URL });
            Cookies.remove("type", { path: "/", domain: globalData.URL });
            Cookies.remove("role", { path: "/", domain: globalData.URL });
            Cookies.remove("username", { path: "/", domain: globalData.URL });
            Cookies.remove("module_privilege", {
              path: "/",
              domain: globalData.URL,
            });
          }, 10);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return !loading ? (
    <>
      {appInitialised && (
        // <ErrorBoundary>
        <Suspense
          callback={console.log("Loading...")}
          fallback={
              localStorage.getItem("currScreen") === "Login" ? null : localStorage.getItem("currScreen") === "register" ? null : localStorage.getItem("currScreen") === "verifyotp" ? null : localStorage.getItem("currScreen") ===
              "forgotpassword" ? null : (
              <Box sx={{ display: "flex" }}>
                <myglobalData.pages.components.leftsidebar
                  dispatch={dispatch}
                  myglobalData={myglobalData}
                />
                <DrawerHeader />
                <Box component="main" sx={{ flexGrow: 1, px: 3, py: 10 }}>
                  <Skeleton variant="rectangular" width="100%" height={30} />
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={300}
                    sx={{ mt: 3 }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="100%"
                    height={300}
                    sx={{ mt: 3 }}
                  />
                </Box>
              </Box>
            )
          }
        >
          {/* <button onClick={notify}>Notify!</button> */}
          <ToastContainer />
          <CustomModal
            show={idleModal}
            hideCloseIcon={true}
            ModalBody={
              <Box className="text-center card-bg p-3">
                <img src={IdleImg} alt="Idle Image" className="w-75 mb-3" />
                <h5 className="text-danger mb-2" style={{ fontSize: "22px" }}>
                  You have been idle for too long time!
                </h5>
                <p
                  className="text-muted w-75 m-auto"
                  style={{ fontSize: "13px" }}
                >
                  would you like to stay logged in? Please respond with a Leave
                  or continue to use the application.
                </p>
                <div className="mt-3">
                  <Button onClick={logout_User} className="idle-leave-btn">
                    Leave
                  </Button>
                  <Button
                    onClick={() => setIdleModal(false)}
                    className="idle-continue-btn"
                  >
                    continue
                  </Button>
                </div>
              </Box>
            }
          />
          <CustomModal
            show={leadModal}
            ModalSize="lg"
            onHide={() => setLeadModal(false)}
            showHeader={true}
            ModalTitle="Update Lead Status"
            ModalBody={<h1>hello world</h1>}
            // ModalBody={<LeadDeatils data={leadData} />}
          />
          {localStorage.getItem("currScreen") === "Login" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />
          ) : localStorage.getItem("currScreen") === "register" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />  
          ) : localStorage.getItem("currScreen") === "verifyotp" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />
          ) : localStorage.getItem("currScreen") === "forgotpassword" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
              token={token}
            />    
          ) : localStorage.getItem("currScreen") === "loader" ? (
            <myglobalData.currScreen
              dispatch={dispatch}
              myglobalData={myglobalData}
            />
          ) : (
            <IdleTimerProvider
              // timeout={1000 * 15}
              timeout={1000 * 60 * 15}
              onIdle={() => setIdleModal(true)}
            >
              <Box style={{ display: "flex" }}>
                <myglobalData.pages.components.leftsidebar
                  dispatch={dispatch}
                  myglobalData={myglobalData}
                />
                <DrawerHeader />
                <Box
                  component="main"
                  sx={{ flexGrow: 1, px: 3, py: 10, overflowX: "hidden" }}
                >
                  <myglobalData.currScreen
                    dispatch={dispatch}
                    myglobalData={myglobalData}
                  />
                </Box>
              </Box>
            </IdleTimerProvider>
          )}
        </Suspense>
        // </ErrorBoundary>
      )}
    </>
  ) : (
    <h1>Loading...</h1>
  );
};

export default Main;
